<template>
  <v-card>
    <v-card-title primary-title class="py-2">
      <div class="subheading">
        {{ $t("view.commons.records") }}
      </div>
      <v-spacer />
      <v-btn icon @click="view.elem.datatable.visible = !view.elem.datatable.visible">
        <v-icon>{{ view.elem.datatable.visible ? "keyboard_arrow_down" : "keyboard_arrow_up" }}</v-icon>
      </v-btn>
    </v-card-title>
    <v-fade-transition>
      <v-card-text v-show="view.elem.datatable.visible" class="pt-0">
        <v-layout row wrap>
          <v-flex xs12 sm9>
            <filters ref="filters" @filter="filter" />
          </v-flex>
          <v-flex md12>
            <v-data-table
              ref="dataTable"
              item-key="clave"
              class="se dataTable"
              sort-by="clave"
              :sort-desc="false"
              :headers="view.elem.datatable.headers"
              :items="view.elem.datatable.data"
              :loading="view.elem.datatable.loading"
              :footer-props="view.elem.datatable.footerprops"
              :must-sort="true"
              :server-items-length="view.elem.datatable.total"
              :options.sync="options">
              <template #top>
                <v-text-field
                  v-model.trim="search"
                  dense
                  clearable
                  hide-details
                  :label="$t('view.commons.search')"
                  append-icon="mdi-magnify"
                  @keydown.enter="refreshSearch"
                  @click:append="refreshSearch"
                  @click:clear="clearSearch" />
              </template>
              <template #item.cuit="{ item }">
                {{ StringMask.apply(item.cuit, "##-########-#") }}
              </template>
              <template #item.accion="{ item }">
                <buttons
                  :ref="`dataTableBtn_${item.clave}`"
                  :key="refreshkey"
                  :clave="item.clave"
                  :descripcion="item.nombre"
                  :showdisable="item.estatus && $userPermission.hasPermission('ROLE_MODIFICAR_OP')"
                  @edit="edit"
                  @disable="disable"
                  @audit="audit" />
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-fade-transition>
  </v-card>
</template>

<script>
import Filters from "@/views/operativos/seOOB/Filters"; /** *******************************/
import SeOobAPI from "@/services/operativos/seOOB"; /** *******************************/
import Buttons from "@/components/datatable/Buttons"; /** *******************************/
import transform from "@/helpers/server-side-datatable";
import tippy from "tippy.js";
import StringMask from "string-mask";
import { disableSwal } from "@/constants/sweet-alerts";
import { handleResponse } from "@/helpers/http-response-handler";

export default {
  name: "DataTable"
  , components: { Buttons, Filters }
  , data() {
    return {
      options: {}
      , filtros: {}
      , search: ""
      , refreshkey: 0
      , StringMask
      , view: {
        elem: {
          datatable: {
            visible: true
            , loading: false
            , data: []
            , total: 0
            , footerprops: { showFirstLastPage: true, "items-per-page-options": [10, 25, 50, 100] }
            , headers: [
              { text: "#", align: "left", sortable: true, class: "clave", cellClass: "clave", value: "clave" }
              , { text: this.$t("view.operativos.seOOB.form.nombre.th"), align: "left", sortable: true, class: "se", cellClass: "nombre", value: "nombre" }
              , { text: this.$t("view.operativos.seOOB.form.cuit.th"), align: "left", sortable: true, class: "cuit", cellClass: "cuit", value: "cuit" }
              , { text: this.$t("view.operativos.seOOB.form.provincia.th"), align: "left", sortable: true, class: "provincia", cellClass: "provincia", value: "provincia" }
              , { text: this.$t("view.operativos.seOOB.form.localidad.th"), align: "left", sortable: true, class: "localidad", cellClass: "localidad", value: "localidad" }
              , { text: this.$t("view.operativos.seOOB.form.email.th"), align: "left", sortable: true, class: "email", cellClass: "email", value: "email" }
              , { text: this.$t("view.operativos.seOOB.form.telefono.th"), align: "left", sortable: true, class: "telefono", cellClass: "telefono", value: "telefono" }
              , { text: this.$t("view.commons.accion"), align: "center", sortable: false, class: "accion", cellClass: "accion", value: "accion" }
            ]
          }
        }
      }
    };
  }
  , watch: {
    options: {
      handler() {
        this.load();
      }
      , deep: true
    }
  }
  , updated() {
    tippy(".btn_tippy", { arrow: true, arrowType: "round", animation: "scale" });
  }
  , methods: {
    prepareData() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;

      let serverSideData = {};
      serverSideData.draw = "0";
      serverSideData.filters = JSON.stringify(this.filtros);
      serverSideData.start = page;
      serverSideData.length = itemsPerPage;
      serverSideData.search = { value: this.search ? this.search : "", regex: false };
      serverSideData.order = { column: sortBy, dir: sortDesc };
      serverSideData.columns = this.view.elem.datatable.headers;
      return transform.transformServerSideRequest(serverSideData);
    }
    , async load() {
      if (!this.filtros || this.filtros == {}) return false;

      this.view.elem.datatable.loading = true;

      const serverSideDataT = this.prepareData();
      const response = await SeOobAPI.list(serverSideDataT);
      const { data, recordsTotal } = response.data;

      this.view.elem.datatable.data = data;
      this.view.elem.datatable.total = Number(recordsTotal);
      this.refreshkey += 1;

      this.view.elem.datatable.loading = false;
    }
    , async edit(clave) {
      this.$emit("editRow", clave);
    }
    , async disable(clave) {
      if ((await this.$swal(disableSwal)).value) {
        if (handleResponse(await SeOobAPI.disable({ clave }))) {
          this.load();
          if (clave == this.$parent.se.clave) this.$emit("editRow", clave);
        }
      }
    }
    , async audit(clave, descripcion) {
      this.$emit("auditRow", clave, descripcion);
    }
    , refreshData() {
      this.load();
    }
    , refreshSearch() {
      this.options.page = 1;
      this.load();
    }
    , clearSearch() {
      this.search = "";
      this.options.page = 1;
      this.load();
    }
    , async filter(filters) {
      let fls = { ...filters };
      Object.keys(fls).forEach(function (key) {
        if (fls[key].length > 0) {
          fls[key] = fls[key].join();
        } else {
          delete fls[key];
        }
      });
      this.filtros = fls;
      await this.load();
    }
  }
};
</script>

<style>
.se .clave {
  min-width: 60px;
}
.se .se {
  min-width: 100px;
}
.se .seller {
  min-width: 100px;
}
.se .cuit {
  min-width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/views/operativos/seOOB/DataTable.vue